import styled from 'styled-components';

export const IFrame = styled.iframe`
    border: 0;
    height: 1500px;
    width: 100%;
`;
